export enum Languages {
 EN = "EN",
  BG = "БГ",
}
